<template>
    <!-- <splash v-show="isLoading" title="심화노트학습" /> -->
    <!-- <customHeader title="마이노트" path="note" /> -->
    <Sat v-if="props.type === 'SAT' && problemIds && !isVoca" :exprVersion="studyStore.exprVersion" :problem-ids="problemIds" @onClickEnd="onClickEnd" :exam-name="props.examNames[examNameId]" title="오답노트" :type="props.type" />
    <Earnest
        v-if="props.type !== 'SAT' && problemIds && !isVoca"
        :exprVersion="studyStore.exprVersion"
        :problem-ids="problemIds"
        @onClickEnd="onClickEnd"
        :exam-name="props.examNames[examNameId]"
        title="오답노트"
        :type="props.type"
        :isLastExam="isLast && lastAreaVoca === isVoca"
        :problems-order-object="problemsOrderObject"
    />
    <Voca
        v-if="props.type !== 'SAT' && problemIds && isVoca"
        :exprVersion="studyStore.exprVersion"
        :problem-ids="problemIds"
        @onClickEnd="onClickEnd"
        :exam-name="props.examNames[examNameId]"
        type="wrong"
        title="오답노트"
        :isLastExam="isLast && lastAreaVoca === isVoca"
    />
</template>

<script setup>
import { getNoteProblemList, postNoteAnswer } from '@/api/modules/note';
import { getKrtExam } from '@/api/modules/qbank';
import customHeader from '@/components/layouts/header/header.vue';
import { analysis, learningType } from '@/helpers/qbankParser/qbankMeta';
import { StudyStore } from '@/store/modules/study';
import { ref, watch, onMounted, onUnmounted, defineProps, defineEmits, toRaw } from 'vue';
import { useRoute } from 'vue-router';
import Earnest from '../components/earnest.vue';
import Voca from '../components/voca.vue';
import Sat from '../components/sat.vue';
import { monitoringLog } from '@/api/modules/monitoring';
import { useLocalLog } from '@/helpers/utils';

const isLoading = ref(true);
const isVoca = ref(false);
const problemIds = ref(null);
const isLast = ref(false);
let lastIndex = 0;
let lastAreaVoca = ref(false);
let examNameId = 0;
let saveDatas = [];
const studyStore = StudyStore();
const route = useRoute();

const props = defineProps({
    examNames: {
        default: [],
    },
    learningType: {
        default: '1',
    },
    type: {
        default: 'NORMAL',
    },
    exprVersion: {
        default: '1.00.01',
        type: String,
    },
});

const problemArrayToUse = ref([]);
const problemsOrderObject = ref({});

console.log('study template props ===', props);

const emit = defineEmits(['close']);

const getLastArea = async () => {
    let tmpData = [];
    let lastExam = 0;
    if (props.examNames) {
        await Promise.all(
            props.examNames.map((i, index) => {
                return getNoteProblemList({ examNameCsv: i, learningType: props.learningType }, (rs) => {
                    if (rs.length > 0) {
                        log && console.log('study == rs : ', rs);
                        const tmp = rs.filter((ii) => {
                            if (!ii.examName.endsWith('_C')) {
                                problemArrayToUse.value.push(ii);
                                log && console.log('study == not C ii : ', ii);
                                return ii;
                            }
                            log && console.log('study == with C ii : ', ii);
                        });
                        log && console.log('study == tmp : ', tmp);
                        if (tmp.length > 0) {
                            tmpData = tmp;
                            lastExam = lastExam < index ? index : lastExam;
                        }
                        log && console.log('study == lastExam : ', lastExam);
                    }
                });
            }),
        );
        log && console.log('study == tmpData : ', tmpData);
        let tmpLast = tmpData.pop();
        log && console.log('study == tmpLast : ', tmpLast);
        lastIndex = lastExam;
        lastAreaVoca = tmpLast?.examName?.endsWith('_W') ? true : false;
        log && console.log('study == lastAreaVoca : ', lastAreaVoca); // 마지막 어휘 있는지 없는지 boolean

        log && console.log('study == lastIndex : ', lastIndex); //0 or 1
        log && console.log('study == examNameId : ', examNameId); 
        getProblemList(props.examNames[examNameId], props.type === 'NORMAL' ? '_R' : '');
    }
    log && console.log('study == problemArrayToUse.value : ', problemArrayToUse.value);
    //TODO: 순서 맞추기
    sortAllProblems(problemArrayToUse.value);
    //객체로 전환
    problemsOrderObject.value = chageToObjectInorder(problemArrayToUse.value);
    log && console.log('study == problemsOrderObject.value : ', problemsOrderObject.value);
};

// 나오는 문제들을 order 순으로 정렬
const sortAllProblems = (data) => {
    // 정렬 기준 순서 정의
    const order = ['01_R', '01_W', '02_R', '02_W'];

    // 데이터 정렬
    data.sort((a, b) => {
        // _R 또는 _W 앞의 숫자를 추출
        const aMatch = a.examName.match(/_(\d{2,3})_[RW]$/);
        const bMatch = b.examName.match(/_(\d{2,3})_[RW]$/);

        // 숫자 부분을 비교
        const aNum = parseInt(aMatch[1]);
        const bNum = parseInt(bMatch[1]);

        if (aNum !== bNum) {
            return aNum - bNum; // 숫자 기준 오름차순 정렬
        } else {
            // 같은 숫자일 경우 _R 먼저, _W 나중에
            return a.examName.endsWith('_R') ? -1 : 1;
        }
    });

    console.log('study == sortAllproblems ', data);
};

//정렬된 데이터를 객체로 변환, 문제 번호를 키로 순서와, 타입은 값으로 사용
//자식 컴포넌트에서 prev 버튼 버그를 해결하기 위해 사용
const chageToObjectInorder = (data) => {
    const result = data.reduce((acc, curr, index) => {
        acc[curr.problemId] = { index, type: curr.examName };
        return acc;
    }, {});

    console.log('study == chageToObjectInorder ', result);
    return result;
};

const getProblemList = (examName, examType) => {
    isLoading.value = true;
    // TODO: 오답문제 API 에서 불러온 오답문제만 리스트에
    getNoteProblemList({ examNameCsv: examName, learningType: props.learningType }, (rs) => {
        let tmpProblemIds = [];
        if (rs) {
            log && console.log('study == getNoteProblemList rs ===', rs);
            log && console.log('study == getNoteProblemList examName ===', examName);
            log && console.log('study == getNoteProblemList examType ===', examType);
            log && console.log('타입 처음엔 _R만 골라내기');
            rs.forEach((item, idx) => {
                if (examType === '_W') {
                    if (item.examName.endsWith('_W')) {
                        tmpProblemIds.push({ ...item, examName: examName + '_W', exprVersion: studyStore.exprVersion });
                    }
                } else if (examType == '_R') {
                    // tmpProblemIds.push({ ...item, analysisOrd: analysis[item.property.analysisId]['ord'], exprVersion: props.exprVersion });
                    if (item.examName.endsWith('_R')) {
                        tmpProblemIds.push({ ...item, examName: examName + '_R', exprVersion: studyStore.exprVersion });
                    }
                } else if (examType == '_C') {
                    // 코어독해는 제외
                } else {
                    tmpProblemIds.push({ ...item, examName: examName, exprVersion: studyStore.exprVersion });
                }
            });

            log && console.log('study == getNoteProblemList tmpProblemIds ===', tmpProblemIds);

            if (tmpProblemIds.length === 0) {
                log && console.log('R이 없다면 W로, 본격이 없다면 어휘로');
                if (props.type === 'NORMAL') {
                    log && console.log('타입 노말');
                    if (!isVoca.value) {
                        getProblemList(props.examNames[examNameId], '_W');
                        isVoca.value = true;
                    } else if (examNameId + 1 < props.examNames?.length) {
                        log && console.log('id가 0인 지문에서 (본격), 어휘가 없다면 다음지문으로.. ');
                        examNameId++;
                        log && console.log('다음 지문으로 R 찾고 W 찾기 examNameId ===', examNameId);
                        getProblemList(props.examNames[examNameId], '_R');
                        isVoca.value = false;
                    } else {
                        log && console.log('코어 제외하고 암것도 없다면 저장하고 닫기');
                        // 저장 로직
                        saveResult();
                        emit('close');
                    }
                } else {
                    console.log('타입 비노말');
                    if (examNameId + 1 < props.examNames?.length) {
                        examNameId++;
                        getProblemList(props.examNames[examNameId], '');
                    } else {
                        // 저장 로직
                        saveResult();
                        emit('close');
                    }
                }
            } else {
                log && console.log('study == 데이터가 있다면 ', tmpProblemIds);
                if (props.type === 'NORMAL') {
                    if (examNameId === lastIndex && lastAreaVoca.value === isVoca.value) {
                        log && console.log('examNameId === lastIndex && lastAreaVoca.value === isVoca.value');
                        isLast.value = true;
                    }
                } else {
                    isLast.value = true;
                }
                problemIds.value = tmpProblemIds;
                log && console.log('study== getProblemList 최종 == problemIds ===', problemIds);
            }
        }
    });
    // getKrtExam({
    //   version: props.exprVersion, examNm: examName + examType
    //   // version: props.exprVersion, examNm: examName + '_W'
    // }, async (rs) => {
    //   let tmpProblemIds = [];
    //   if (rs && rs.examMaps) {
    //     const exId = rs.examIds[0];
    //     rs.examMaps[exId].forEach(item => {
    //       if (examType !== '_W') {
    //         if (item.difficultCd === '05') {
    //           tmpProblemIds.push({ ...item, analysisOrd: analysis[item.property.analysisId]['ord'], exprVersion: props.exprVersion });
    //         }
    //       } else {
    //         tmpProblemIds.push({ ...item, exprVersion: props.exprVersion });
    //       }
    //     });
    //     problemIds.value = tmpProblemIds;
    //   }
    // });
};

const saveResult = () => {
    //
    saveDatas.forEach((item) => {
        item.learningType = props.learningType;
    });
    postNoteAnswer(saveDatas, (rs) => {
        //
    });
};
// 본격, 어휘 에서 마지막 클릭시 호출
const onClickEnd = (data) => {
    log && console.log('onClickEnd data ===', data);
    if (data) {
        problemIds.value = null;
        const tmpData = toRaw(data);
        Object.values(tmpData).forEach((i) => {
            saveDatas.push(i);
        });
        if (props.type === 'NORMAL') {
            if (!isVoca.value) {
                getProblemList(props.examNames[examNameId], '_W');
                isVoca.value = true;
            } else if (examNameId + 1 < props.examNames?.length) {
                examNameId++;
                getProblemList(props.examNames[examNameId], '_R');
                isVoca.value = false;
            } else {
                // 저장 로직
                saveResult();
                emit('close');
            }
        } else {
            if (examNameId + 1 < props.examNames?.length) {
                examNameId++;
                getProblemList(props.examNames[examNameId], '');
            } else {
                // 저장 로직
                saveResult();
                emit('close');
            }
        }
    } else {
        emit('close');
    }
};

watch(
    () => props.examNames,
    (newValue) => {
        examNameId = 0;
        // getLastArea();
        if (props.examNames && props.examNames.length > 0) {
            if (props.type === 'NORMAL') {
                getLastArea();
            } else {
                getProblemList(props.examNames[examNameId], props.type === 'NORMAL' ? '_R' : '');
            }
        }
    },
);

/* LOG 셋팅, local 일때만 로그 */
let log = useLocalLog();

onMounted(() => {
    // getLastArea()
    if (props.examNames && props.examNames.length > 0) {
        if (props.type === 'NORMAL') {
            log & console.log('중위 == getLastArea');
            getLastArea();
        } else {
            log & console.log('중위 == getProblemList');
            getProblemList(props.examNames[examNameId], props.type === 'NORMAL' ? '_R' : '');
        }

        let data = {
            menuName: route.path.split('/').join(''),
            examName: props.examNames[0],
        };
        monitoringLog(data, (res) => {
            console.log('study monitoringLog API response ===', res);
        });
    }
});

onUnmounted(() => {
    monitoringLog({ menuName: 'note' }, (res) => {
        console.log('studyEnd monitoringLog API response ===', res);
    });
});
</script>

<style scoped lang="scss">
.page__wrap {
    height: 100%;
    background-color: #fafafa;
    padding: 3.5vmin 5.2vmin;

    .btn__filter {
        color: #000000;
        font-size: 1.5vmin;
        font-weight: 500 !important;
        border: 2px solid #8e8e8e;
        border-radius: 8px;
        padding: 1vmin 2vmin;

        .q-btn__content {
            .block {
                font-weight: 500 !important;
            }
        }
    }
}

.title {
    color: #222222;
    font-size: 2.1vmin;
    font-weight: 700;
    margin: 2.5vmin 0 2.5vmin;
}

.my-card {
    border: 1px solid #e0e0e0;
    background: #fff;
    border-radius: 1vmin;
    padding: 3.1vmin 4.2vmin;
    margin: 1vmin 0;
}

.modal {
    .title {
        color: #222222;
        font-size: 2.1vmin;
        font-weight: 700;
        margin: 1.75vmin 0vmin 0.5vmin;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    &__wrap {
        width: 50vw;
        min-width: 500px;
        max-width: 1000px;
        border-radius: 2.5vmin;
    }

    &__content {
        padding: 0vmin 3.5vmin 2vmin;
    }

    &__checkbox ::v-deep {
        font-size: 1.6vmin;
    }

    .q-option-group ::v-deep {
        .q-checkbox__bg {
            border-radius: 50% !important;
        }
    }

    .q-checkbox ::v-deep {
        .q-checkbox__bg {
            border-radius: 50% !important;
        }
    }

    .btn {
        border-radius: 1vmin;
        margin-bottom: 2vmin;
    }

    .close {
        margin: 1.5vmin;
    }

    .q-option-group {
        ::v-deep > div {
            width: 23%;
        }
    }
}
</style>
